/* eslint-disable */
<template>
  <v-app>
    <!-- Body-Intro-area -->

    <!-- Intro badge -->

    <kinesis-container>
      <kinesis-element :strength="6" >
        <div class="text-xs-center">
          <v-container
            style="max-width: 700px; margin-top: 70px; margin-bottom: 70px"
            class="py-0">
            <v-flex class="hidden-sm-and-down">
              <div class="customdividermini mt-4 mb-4"/>
              <h3 class="py-2">
                <span class="font-italic pr-1">EverOwl</span> is built based on dedication, passion and
                <br>hardwork. To reach beyond our limits.
                <br>To make dreams a reality.
              </h3>
              <div class="customdividermini my-4"/>
            </v-flex>

            <v-flex class="hidden-md-and-up px-4">
              <div
                class="customdividermini mt-4 mb-4"
                style="width: 120px;"/>
              <p style="font-size: 20px !important">
                <span class="font-italic pr-1">EverOwl</span> is built based on dedication, passion and hardwork
                To reach beyond our limits. To make dreams a reality.
              </p>
              <div
                class="customdividermini mt-4 mb-5"
                style="width: 120px;"/>
            </v-flex>
          </v-container>
        </div>
      </kinesis-element>
      <kinesis-element :strength="10" >
        <v-flex
          xs12
          text-xs-center
          class="hidden-sm-and-down">
          <v-card flat>
            <img
              class="introBadge"
              src="/img/Intro-Badge2.svg"
              alt="Intro-Badge.svg"
            >
          </v-card>
        </v-flex>
      </kinesis-element>
    </kinesis-container>

    <!-- THE TRASH PART -->
    <v-container
      grid-list-md
      text-xs-center
      class="px-0 my-5">

      <v-layout
        row
        wrap>
        <v-flex
          xs12
          md4>
          <v-card flat>
            <div class="boxfeature">
              <div class="boxfeature-icon">
                <img
                  src="/img/Service-Icon-1.svg"
                  style="height: inherit;">
              </div>
              <h4>Simple</h4>
              <p>We design our products based on the princple of simplicity. Simplicity is the ultimate sophistication.</p>
            </div>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md4>
          <v-card flat>
            <div class="boxfeature">
              <div class="boxfeature-icon">
                <img
                  src="/img/Service-Icon-2.svg"
                  style="height: inherit;">
              </div>
              <h4>Elegant</h4>
              <p>We design our products based on the princple of elegance. Elegance is what organises chaos into tranquility.</p>
            </div>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md4>
          <v-card flat>
            <div class="boxfeature">
              <div class="boxfeature-icon">
                <img
                  src="/img/Service-Icon-3.svg"
                  style="height: inherit;">
              </div>
              <h4>Trust</h4>
              <p>We design our products based on the principle of trust. Without trust, there is no success.</p>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container
      fluid
      style="max-width: 1600px !important"
      class="px-4 pb-5 mb-2">
      <v-layout
        row
        wrap>
        <v-flex
          xs12
          lg6
          class="pb-3">
          <v-card
            id="phone-img"
            class="emailCard newAnimationCard ma-3 pt">
            <v-flex class="xs12 md7 lg8 pt-4 px-4 emailCardText">
              <h2
                class="mobileapp-font-main font-weight-bold white--text my-2"
                style="text-transform: uppercase"
              >Mobile Development</h2>
              <p
                class="mobileapp-font-sub font-weight-regular white--text my-2"
              >Built Based On Your Needs</p>
              <p
                class="white--text"
              >With mobile applications playing an evermore pivotal role in businesses, relying on a workforce that tailors towards your customer base is key to ensure quick access to on-demand information and solutions.</p>
              <v-btn
                :to="{path: 'app-development'}"
                round
                color="#2c8bbc"
                style="z-index: 1"
              >Learn More</v-btn>
            </v-flex>
            <div class="outerMobileImage">
              <img
                class="mobileImage"
                src="/img/Phone-Banner.png"
              >
            </div>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          lg6
          class="pb-3">
          <v-card class="webDevCard ma-3">
            <div class="outerTopMobileImage">
              <img
                class="desktopMobileImage"
                src="/img/Desktop-Banner.png"
              >

              <div style="margin-top: -50px; min-height: 170px">
                <v-layout justify-center>
                  <div
                    class="px-4 pt-2"
                    style="position: absolute; bottom: 10px">
                    <h2
                      class="webdevelop-font-main font-weight-bold pl-2 pt-3 my-2 white--text"
                    >Web Development</h2>
                    <p
                      class="webdevelop-font-sub px-2 my-2 white--text"
                    >Get a new website to brand yourself better and gain greater coverage over customers.</p>
                    <v-btn
                      :to="{path: 'web-development'}"
                      class="ml-2"
                      round
                      color="#ff3a56"
                      style="float: right;"
                    >Check Here</v-btn>
                  </div>
                </v-layout>
              </div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-container fluid style="max-width: 1600px !important" class="px-4 pt-0">
      <v-card class="extraCard ma-3">
        <v-layout>
          <v-flex align-self-end class="pl-5 pt-3" xs10 md10>
            <h2 class="load-font-main my-2">IT SOLUTIONS</h2>
            <p class="load-font-sub my-2">
              Got a problem? Problems often comes in various complexity. Maybe we can provide a technical solution.
              Drop us a message and we'll start brainstorming ideas for you. With proper analysis, a solution may be easily formulated.
            </p>
            <v-btn class="mt-3" round color="#ff3a56" :to="{path: 'contact-us'}">Drop Us A Message</v-btn>
          </v-flex>
          <v-flex md6 hidden-xs-only>
            <img
              style="display: block; margin-left: auto; max-width: 100%"
              src="https://codecrew.us/wp-content/themes/CodeCrew_WP/images/widget-slide-6.png"
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-container> -->

    <kinesis-container>
      <kinesis-element :strength="6" >
        <div class="text-xs-center">
          <v-container
            style="max-width: 700px; margin-top: 70px; margin-bottom: 70px"
            class="py-0">
            <v-flex class="hidden-sm-and-down">
              <div class="customdividermini mt-4 mb-4"/>
              <h3 class="py-2">
                <span class="font-italic pr-1">EverOwl</span> leads with integrity and perseverance.
                <br>It is the seed of achievement and triumph.
                <br>A principle that never fails.
              </h3>
              <div class="customdividermini my-4"/>
            </v-flex>

            <v-flex class="hidden-md-and-up px-4">
              <div
                class="customdividermini mt-4 mb-4"
                style="width: 120px;"/>
              <p style="font-size: 20px !important">
                <span class="font-italic pr-1">EverOwl</span> leads with integrity and perseverance.
                <br>It is the seed of achievement and triumph.
                <br>A principle that never fails.
              </p>
              <div
                class="customdividermini mt-4 mb-5"
                style="width: 120px;"/>
            </v-flex>
          </v-container>
        </div>
      </kinesis-element>
      <!-- <kinesis-element :strength="10" >
        <v-flex
          xs12
          text-xs-center
          class="hidden-sm-and-down">
          <v-card flat>
            <img
              class="introBadge"
              src="/img/Intro-Badge2.svg"
              alt="Intro-Badge.svg"
            >
          </v-card>
        </v-flex>
      </kinesis-element> -->
    </kinesis-container>

    <!------------ Testimonial Section --------------->
    <Testimonials class="pb-5 mb-5"/>
    <!------------------ Get in touch banner section ---------------->

    <GetInTouch/>
  </v-app>
</template>

<script>
import Testimonials from '../components/LandingPage/Testimonials'
import GetInTouch from '../components/LandingPage/GetInTouch'
export default {
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Everowl Technologies',
      // all titles will be injected into this template
      titleTemplate: 'Application Development, Web Design Company in Malaysia | %s',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'We are an application development and web design company in Malaysia. We provide IT solutions that can help improve your business operation to help you see results. Drop us a message for a free consultation' },
        { name: 'keywords', content: 'web design malaysia, mobile app developer malaysia, mobile application development, web design kl, web app development, website & application developer malaysia, IT solutions, Everowl Technologies Malaysia' }
      ]
  },

  components: {
    Testimonials,
    GetInTouch
  },
  data: () => ({
  }),
  mounted () {
  }
}
</script>

<style>
/* Intro Badge */
.introBadge {
  width: 60%
}

/* Divider Line*/
.customdividermini {
  width: 150px;
  text-align: center;
  border-bottom: 1px solid rgba(131, 153, 255, 0.603);
  line-height: 0.1em;
  margin-left: auto;
  margin-right: auto;
}

/**
*Box-style
**/

.boxfeature {
  padding: 50px 30px;
  text-align: center;
  -webkit-box-shadow: 0 0 0 0 #ffffff;
  box-shadow: 0 0 0 0 #ffffff;
  -webkit-transition: 1s;
  transition: 1s;
  border-radius: 5px;
  -webkit-transform: translateY(0);
  transform: translateY(0);
}

.boxfeature:hover {
  border-radius: 30px;
  background-color: #fefefe;
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
  -webkit-box-shadow: -2px 54px 30px -31px rgba(97, 97, 97, 0.22);
  -moz-box-shadow: -2px 54px 30px -31px rgba(97, 97, 97, 0.22);
  box-shadow: -2px 54px 30px -31px rgba(97, 97, 97, 0.22);
}

.boxfeature h4 {
  text-transform: uppercase;
}

.boxfeature .boxfeature-icon {
  height: 200px;
  margin-bottom: 20px;
}

.boxfeature .boxfeature-icon img {
  /* -webkit-filter: grayscale(70%);
  filter: grayscale(70%); */
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.boxfeature:hover .boxfeature-icon img {
  /* -webkit-filter: grayscale(0);
  filter: grayscale(0); */
}

/* NICKS CODE */

.emailCard:hover > .outerMobileImage {
  right: -40px;
}

.outerTopMobileImage:hover > .desktopMobileImage {
  margin-left: -15px;
}

.extraCard {
  height: 100%;
  background-image: linear-gradient(
    to top,
    #f6f9fe 0%,
    #f6f9fe 1%,
    #f6f9fef1 100%
  );
}

.emailCard {
  overflow: hidden;
  height: 100%;
  background: #38AEEC; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left top,
    #38AEEC,
    #9CE6DD
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    bottom right,
    #38AEEC,
    #9CE6DD
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    bottom right,
    #38AEEC,
    #9CE6DD
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to bottom right,
    #38AEEC,
    #9CE6DD
  ); /* Standard syntax */
}

.webDevCard {
  height: 100%;
  background: #FBAB7E; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left top,
    #FBAB7E,
    #F7CE68
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    bottom right,
    #FBAB7E,
    #F7CE68
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    bottom right,
    #FBAB7E,
    #F7CE68
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to bottom right,
    #FBAB7E,
    #F7CE68
  ); /* Standard syntax */
}

.emailCardText {
  min-height: 320px;
}

.outerMobileImage {
  position: absolute;
  overflow: hidden;
  display: block;
  height: 100%;
  width: 100%;
  bottom: 0;
  margin-right: auto;
  right: 0;
  -webkit-transition: 1s;
  transition: 1s;
}

.mobileImage {
  position: absolute;
  display: block;
  max-width: 70%;
  height: auto;
  z-index: 1;
  bottom: -50px;
  margin-right: auto;
  right: -65px;
}

.mobile-image-animated {
  -webkit-animation: floatOutBubble 1s normal ease-out;
  animation: floatOutBubble 1s normal ease-out;
  bottom: 0px;
  right: 0px;
}

@-webkit-keyframes floatOutBubble {
  0% {
    bottom: -50px;
    right: -50px;
  }
  100% {
    bottom: 0px;
    right: 0px;
  }
}
@keyframes floatOutBubble {
  0% {
    bottom: -50px;
    right: -50px;
  }
  100% {
    bottom: 0px;
    right: 0px;
  }
}

.webapp-container {
  position: absolute;
}

.outerTopMobileImage {
  overflow: hidden;
  width: 100%;
}

.desktopMobileImage {
  display: block;
  height: auto;
  margin-right: auto;
  width: 70%;
  margin-left: -50px;
  margin-right: -50px;
  -webkit-transition: 1s;
  transition: 1s;
}

.desktop-image-animated {
  -webkit-animation: topFloatOutBubble 1s normal ease-out;
  animation: topFloatOutBubble 1s normal ease-out;
  margin-left: 0px;
  margin-right: 0px;
}

@-webkit-keyframes topFloatOutBubble {
  0% {
    margin-left: -50px;
    margin-right: -50px;
  }
  50% {
    margin-left: 0px;
    margin-right: 0px;
  }
  100% {
    margin-left: -50px;
    margin-right: -50px;
  }
}
@keyframes topFloatOutBubble {
  0% {
    margin-left: -50px;
    margin-right: -50px;
  }
  50% {
    margin-left: 0px;
    margin-right: 0px;
  }
  100% {
    margin-left: -50px;
    margin-right: -50px;
  }
}

.mobileapp-font-main {
  font-size: 16px !important;
}

.mobileapp-font-sub {
  line-height: 1.2 !important;
  font-size: 40px !important;
}

.webdevelop-font-main {
  text-transform: uppercase;
  font-size: 14px !important;
}

.webdevelop-font-sub {
  font-size: 24px !important;
  line-height: 1.4 !important;
}

.load-font-main {
  font-size: 20px !important;
}

.load-font-sub {
  font-size: 14px !important;
  line-height: 2 !important;
}

@media (max-width: 960px) {
  .outerMobileImage {
    position: relative;
  }

  .emailCardText {
    min-height: 0px;
  }

  .mobileImage {
    max-width: 60%;
    position: relative;
    float: right;
    bottom: -35px;
    right: 0px;
    -webkit-animation: none;
    animation: none;
  }

  .emailCard:hover .mobileImage {
    -webkit-animation: none;
    animation: none;
  }

  .desktopMobileImage {
    margin-left: 0px;
    margin-right: 0px;
    -webkit-animation: none;
    animation: none;
  }

  .webDevCard:hover .desktopMobileImage {
    -webkit-animation: none;
    animation: none;
  }

  .mobile-app-font {
    font-size: 24px !important;
  }

  .webapp-container {
    padding: 0 10px;
  }

  .mobileapp-font-sub {
    font-size: 28px !important;
  }

  .webdevelop-font-sub {
    font-size: 16px !important;
  }
}

/* Mobile Layout: 320px. */
@media only screen and (max-width: 600px) {
  .introBadge {
  width: 90%
}
}

</style>
